import api from "../utils/API";

// Base URL for your API
export const dashboardService = {
  fetchCardCounts: async () => {
    try {
      const response = await api.get("/admin/dashboard/counts");
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchDashboardSalesTrend: async (payload) => {
    try {
      const response = await api.get("/admin/dashboard/sales-trend", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchDashboardDealersPerformance: async (payload) => {
    try {
      const response = await api.get("/admin/dashboard/dealers-performance", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchDashboardDealersOnboardingTrend: async (payload) => {
    try {
      const response = await api.get("/admin/dashboard/dealers-onboarding-trend", {
        params: payload,
      });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },
  fetchDashboardActiveCampaign: async (payload) => {
    try {
      const response = await api.get("/admin/dashboard/active-campaign", { params: payload });
      return response?.data;
    } catch (error) {
      return error.response.data;
    }
  },
};
